export default "__VITE_ASSET__15d2fdde__"